import { defineStore } from 'pinia';
import { ref } from 'vue';

export interface SessionResponse {
  sessionId: string;
}

export const useSessionStore = defineStore('sessionStore', () => {
  const sessionId = ref<string>('');

  async function fetchSessionId() {
    const response = await useNuxtApp().$siteFetch<SessionResponse>('/api/v1/chat/scrappingSession');
    if (response?.sessionId) {
      sessionId.value = response.sessionId;
    }

    return response;
  }

  function $reset() {
    sessionId.value = '';
  }

  return {
    sessionId,
    fetchSessionId,
    $reset,
  };
});
